var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.onlyText)?_c('span',{staticClass:"document-status",class:`document-status--${_vm.value}`},[_c('span',{staticClass:"document-status__dot mr-2",class:`document-status__dot--${_vm.value}`}),_c('span',[_vm._v(_vm._s(_vm.statusText))])]):_c('span',{staticClass:"no-bg",class:`document-status--${_vm.value}`},[_vm._v(_vm._s(_vm.statusText))])
}
var staticRenderFns = []

export { render, staticRenderFns }